import { buildCurrentUserResponseOrEmpty } from './CadPiiCurrentUserResponse';
import { buildRefCodeDataOrEmpty } from './RefCodeData';
import { buildEloquaExtraDataOrEmpty } from './EloquaExtraData';
import { buildSignupDecorationOrUndefined } from '../personalization/SignupDecoration';
export const buildWwwSsoUserOrEmpty = (data) => {
    var _a;
    if (!data) {
        return {
            _id: '',
            _type: 'ssoUser',
            _createdAt: '',
            _updatedAt: '',
            _rev: '',
            email: '',
            firstName: '',
            lastName: '',
            name: '',
            planGroup: 'Other',
            image: '',
            refCodeData: buildRefCodeDataOrEmpty({}),
            cadPiiCurrentUserResponse: buildCurrentUserResponseOrEmpty({}),
            eloquaExtraData: buildEloquaExtraDataOrEmpty({}),
            signupDecoration: buildSignupDecorationOrUndefined({}),
            lastFetched: undefined,
        };
    }
    return {
        _id: data._id,
        _type: 'ssoUser',
        _createdAt: data._createdAt,
        _updatedAt: data._updatedAt,
        _rev: data._rev,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        name: data.name,
        planGroup: data.planGroup,
        image: data.image,
        refCodeData: buildRefCodeDataOrEmpty(data.refCodeData),
        cadPiiCurrentUserResponse: buildCurrentUserResponseOrEmpty(data.cadPiiCurrentUserResponse),
        eloquaExtraData: buildEloquaExtraDataOrEmpty(data.eloquaExtraData),
        signupDecoration: buildSignupDecorationOrUndefined(data.signupDecoration),
        lastFetched: (_a = data.lastFetched) !== null && _a !== void 0 ? _a : undefined,
    };
};
